"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SavingsAndPromosCms = void 0;
var SavingsAndPromosCms = /** @class */ (function () {
    function SavingsAndPromosCms() {
        this.panelLabel = 'Savings & promotions';
        this.combiendSavingsLabel = "Nice! You'll save {0}/mo. and enjoy a one-time savings of {1}.";
        this.monthlySavingsTitle = "YOUR TOTAL MONTHLY SAVINGS ";
        this.monthlySavingsLabel = "Nice! You'll save {0} each month.";
        this.oneTimeSavingsTitle = "YOUR TOTAL ONE-TIME SAVINGS";
        this.oneTimeSavingsLabel = "Nice! You'll save {0} with this order.";
        this.autoPayLabel = "AutoPay and paperless billing discount";
        this.deviceBillCreditLabel = "Device bill credit";
        this.byodDeviceBillCredit = "Device bill credit for {0} mos.";
        this.accessoryDiscountLabel = "Accessory discount(s)";
        this.activationLabel = "Waived activation fee(s)";
        this.upActivationLabel = "Waived upgrade fee(s)";
    }
    return SavingsAndPromosCms;
}());
exports.SavingsAndPromosCms = SavingsAndPromosCms;
//# sourceMappingURL=SavingsAndPromos.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/panels/SavingsAndPromos/SavingsAndPromos.cms.js
// module id = 569
// module chunks = 8